import { render } from "./AuditLog.vue?vue&type=template&id=1b6e6532"
import script from "./AuditLog.vue?vue&type=script&lang=js"
export * from "./AuditLog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__